import { IRenderMetadata } from '@/components/month-calendar/month-calendar.controller';
import { IMonthCalendarEvent } from '@/components/month-calendar/types/IMonthCalendarEvent';
import { Box, Text } from '@chakra-ui/react';
import { Temporal } from 'temporal-polyfill';

interface IProps {
	onEventClick: (event: IMonthCalendarEvent) => void;
	event: IMonthCalendarEvent;
	locale: string;
	plainDate: Temporal.PlainDate;
	timeZone: string;
	metadata: IRenderMetadata;
}

export default function CalendarEvent(props: IProps) {
	function handleEventClick(e: React.MouseEvent<HTMLElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		props.onEventClick(props.event);
	}

	function handleMouseUp(e: React.MouseEvent<HTMLElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
	}

	function handleMouseDown(e: React.MouseEvent<HTMLElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
	}

	return (
		<Box
			cursor="pointer"
			zIndex={1}
			gridRow={props.metadata.row}
			bg="primary.100"
			onClick={handleEventClick}
			onMouseUp={handleMouseUp}
			onMouseDown={handleMouseDown}
			borderRadius="none"
			w="full"
			alignItems="center"
			overflow="hidden"
			py={1}
			whiteSpace="nowrap"
			fontSize="x-small"
			textAlign="left"
			display="grid"
			borderTopWidth={0.5}
			borderBottomWidth={0.5}
			borderLeftWidth={props.metadata.starts ? 3 : 0}
			borderRightWidth={props.metadata.ends ? 3 : 0}
			borderColor="primary.400"
		>
			<Text textAlign="center" px={2}>
				{props.event.title}
			</Text>
		</Box>
	);
}
